var _rect, _rect2, _rect3, _rect4, _path, _mask, _path2, _path3, _rect5, _rect6, _path4, _rect7, _rect8, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 21,
    x: 8.5,
    y: 10.5,
    fill: "#fff",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 21,
    x: 8.5,
    y: 10.5,
    stroke: "#CDD5DF",
    rx: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 11,
    x: 13.5,
    y: 15.5,
    fill: "#FFEEE5",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 11,
    x: 13.5,
    y: 15.5,
    stroke: "#FFBFA1",
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#99A4B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m56.5 19.5-3 3-3-3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 37a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v29H8V37Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M8 37a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v29H8V37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD5DF",
    d: "M7 37a3 3 0 0 1 3-3h52a3 3 0 0 1 3 3h-2a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1H7Zm57 29H8h56ZM7 66V37a3 3 0 0 1 3-3v2a1 1 0 0 0-1 1v29H7Zm55-32a3 3 0 0 1 3 3v29h-2V37a1 1 0 0 0-1-1v-2Z",
    mask: "url(#b)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 14.5,
    y: 42.5,
    fill: "#fff",
    rx: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 14.5,
    y: 42.5,
    stroke: "#CC3D00",
    rx: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC3D00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.5 47 1.5 2 3.5-4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 8,
    x: 28,
    y: 43,
    fill: "#E3E8EF",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 14.5,
    y: 55.5,
    fill: "#fff",
    stroke: "#CDD5DF",
    rx: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 8,
    x: 28,
    y: 56,
    fill: "#E3E8EF",
    rx: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 36,
    x2: 36,
    y1: 35,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.9770668f6ae1bf4d3b439b1d90948e94.svg";
export { ForwardRef as ReactComponent };